const LoadingIcon = (props) => {

    const { className } = props;

    return (
        <i className={"fa-solid fa-spinner-third fa-spin "  + (className ? className : "")}></i>
    )
}

export default LoadingIcon;